import React from "react";

import * as IconsSVG from "../../assets/iconsSVG";
import * as Styles from "./styles";

export const CustomOption = ({ option }: any) => (
  <Styles.Container>
    {option.nome}{" "}
    {option.resultadoAtualizaLead ? (
      <>
        <IconsSVG.CheckIcon className="check-icon" />
      </>
    ) : (
      <></>
    )}
  </Styles.Container>
);
